function r(r){if(""!==r){if(null===r)return null;if(/\.$/.test(r))return r;if(/\.0$/.test(r))return r;if(/\.\d*0$/.test(r))return r;var t=Number(r);return"number"==typeof t&&!Number.isNaN(t)?t:r}}export{r as default};
